'use client';

import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faSitemap, faUsers, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { usePathname } from 'next/navigation';

const profileLinks = [
  { href: '/profil/sejarah-visi-misi', label: 'Sejarah & Visi Misi', icon: 'history' },
  { href: '/profil/struktur-organisasi', label: 'Struktur Organisasi', icon: 'sitemap' },
  { href: '/profil/pimpinan', label: 'Pimpinan', icon: 'users' },
  { href: '/profil/peta-kampus', label: 'Peta Kampus', icon: 'map-marked-alt' },
];

const iconMap: { [key: string]: any } = {
  'history': faHistory,
  'sitemap': faSitemap,
  'users': faUsers,
  'map-marked-alt': faMapMarkedAlt,
};

export default function ProfileNav() {
  const pathname = usePathname();

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">Halaman Profil Lainnya</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {profileLinks.map((link) => {
            const isActive = pathname === link.href;
            return (
              <Link
                key={link.href}
                href={link.href}
                className={`p-4 rounded-xl flex items-center gap-3 shadow transition ${isActive
                    ? 'bg-unmulGreen text-white shadow-lg'
                    : 'bg-white hover:shadow-lg border border-gray-100'
                  }`}
              >
                <FontAwesomeIcon icon={iconMap[link.icon]} className={`${isActive ? 'text-unmulYellow' : 'text-unmulGreen'}`} />
                <span className={`font-medium ${isActive ? '' : 'text-gray-700'}`}>{link.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
